var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustpilotStar = function SvgTrustpilotStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00B67A",
    d: "M16 0H0v16h16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m7.998 10.783 2.434-.617 1.016 3.133zm5.6-4.05H9.315L7.998 2.699 6.682 6.733H2.398l3.467 2.5-1.317 4.033 3.467-2.5 2.133-1.533z"
  })));
};
export default SvgTrustpilotStar;